import { render, staticRenderFns } from "./EditOrder.vue?vue&type=template&id=1ec2aba1&scoped=true"
import script from "./EditOrder.vue?vue&type=script&lang=js"
export * from "./EditOrder.vue?vue&type=script&lang=js"
import style0 from "./EditOrder.vue?vue&type=style&index=0&id=1ec2aba1&prod&lang=scss"
import style1 from "./EditOrder.vue?vue&type=style&index=1&id=1ec2aba1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec2aba1",
  null
  
)

export default component.exports